import { connect, ConnectedProps } from 'react-redux'

import QaAccordionSkeleton from 'components/accordion/QaAccordionSkeleton'
import { RootState } from 'redux/store'

const mapStateToProps = (state: RootState): { windowHeight: RootState['layout']['windowHeight'], headerHeight: RootState['layout']['headerHeight'], sectionId: RootState['qa']['sectionId'], sectionsMap: RootState['qa']['sectionsMap'], flavour: RootState['layout']['flavour'] } => ({
  windowHeight: state.layout.windowHeight,
  headerHeight: state.layout.headerHeight,
  sectionId: state.qa.sectionId,
  sectionsMap: state.qa.sectionsMap,
  flavour: state.layout.flavour
})

export const connector = connect(mapStateToProps, null)
export type QAccordionSkeletonContainerProps = ConnectedProps<typeof connector>

export default connector(QaAccordionSkeleton)
